module.exports = __webpack_public_path__ + "static/media/21ECLAC50.0a05b096.jpg";